import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { InputWrap, SearchInput, LookupButton } from './styles';
import { breakpoint } from '../../theme/breakpoint';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  ${breakpoint.tablet`
    flex-direction: row;
  `};
`;
/**
 * Allows the user to enter a postcode
 */
const PostcodeLookup = ({ lookup }) => {
  const [postcode, setPostcode] = useState('');
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <label htmlFor="postcode">Enter your postcode</label>
      <Wrap>
        <InputWrap>
          <SearchInput
            onChange={(e) => setPostcode(e.target.value)}
            value={postcode}
            id="postcode"
          />
        </InputWrap>

        <LookupButton bg="secondary-standard" onClick={() => lookup(postcode)}>
          Lookup
        </LookupButton>
      </Wrap>
    </form>
  );
};

PostcodeLookup.propTypes = {
  /** The function that performs the lookup */
  lookup: PropTypes.func.isRequired,
  /** Indicate to the location selector that an alternative method should be used */
  // cancel: PropTypes.func.isRequired,
};

export default PostcodeLookup;
